var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallgridview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4206 2.624H16.0339C16.7652 2.624 17.3682 3.22408 17.3682 3.97615V6.61128C17.3682 7.3627 16.765 7.96343 16.0339 7.96343H13.4206C12.6884 7.96343 12.0855 7.36252 12.0855 6.61128V3.97615C12.0855 3.22425 12.6883 2.624 13.4206 2.624ZM3.95132 2.624H6.56378C7.29611 2.624 7.89892 3.22425 7.89892 3.97615V6.61128C7.89892 7.36252 7.29594 7.96343 6.56378 7.96343H3.95132C3.21916 7.96343 2.61619 7.36252 2.61619 6.61128V3.97615C2.61619 3.22425 3.21899 2.624 3.95132 2.624ZM3.95132 12.0366H6.56378C7.29594 12.0366 7.89892 12.6366 7.89892 13.3895V16.0239C7.89892 16.7758 7.29611 17.376 6.56378 17.376H3.95132C3.21899 17.376 2.61619 16.7758 2.61619 16.0239V13.3895C2.61619 12.6366 3.21916 12.0366 3.95132 12.0366ZM13.4206 12.0366H16.0339C16.765 12.0366 17.3682 12.6365 17.3682 13.3895V16.0239C17.3682 16.7759 16.7652 17.376 16.0339 17.376H13.4206C12.6883 17.376 12.0855 16.7758 12.0855 16.0239V13.3895C12.0855 12.6366 12.6884 12.0366 13.4206 12.0366Z",
    stroke: "#232323",
    strokeWidth: 1.248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallgridview);
export default __webpack_public_path__ + "static/media/smallgridview.4e0273fa922a8b700117a9b947c12f95.svg";
export { ForwardRef as ReactComponent };